module.exports = __webpack_public_path__ + "static/media/costcontrol4.be2806e1.png";